import { CircularProgressClassKey } from '@material-ui/core/CircularProgress'
import { StyleRules } from '@material-ui/core/styles/withStyles'
import { AtlasActionPrimaryActive } from 'assets/styles/variables'

export const MuiCircularProgress: Partial<StyleRules<CircularProgressClassKey, {}>> = {
    colorPrimary: {
        color: AtlasActionPrimaryActive
    }
}
